import { createStore } from 'vuex'
import router from '../router'
import axios from 'axios'
import categories from './data/categories'


export default createStore({
  state() {
    return {
      server: process.env.NODE_ENV === 'development' ? 'http://127.0.0.1:8000/api/v1/' : 'https://api.vaniplate.com/api/v1/',
      static_server: process.env.NODE_ENV === 'development' ? 'http://127.0.0.1:8000/static/' : 'https://api.vaniplate.com/static/',
      media_server: process.env.NODE_ENV === 'development' ? 'http://127.0.0.1:8000/media/' : 'https://api.vaniplate.com/media/',

      small_states: ['alaska', 'michigan', 'vermont', 'rhodeisland', 'westvirginia', 'louisiana', 'newmexico', 'pennsylvania', 'delaware', 'virginia'],
      states: ['alabama', 'alaska', 'arizona', 'arkansas', 'california', 'colorado', 'connecticut', 'delaware', 'florida', 'georgia', 'hawaii', 'idaho', 'illinois', 'indiana', 'iowa', 'kansas', 'kentucky', 'louisiana', 'maine', 'maryland', 'massachusetts', 'michigan', 'minnesota', 'mississippi', 'missouri', 'montana', 'nebraska', 'nevada', 'newhapshire', 'newjersey', 'newmexico', 'newyork', 'northcarolina', 'northdakota', 'ohio', 'oklahoma', 'oregon', 'pennsylvania', 'rhodeisland', 'southcarolina', 'southdakota', 'tennessee', 'texas', 'utah', 'vermont', 'virginia', 'washington', 'westvirginia', 'wisconsin', 'wyoming'],
      state_text: ['bitcoin', 'gmeon', 'crypto', 'nowife', 'ceo', 'webmony', 'chwbca', 'relest8','wall st', 'winning', 'lawyer'],
      links: [
        {name: 'Home', link: '/'},
        {name: 'My Vanidea', link: '/vanidea'},
        {name: 'Insurance', link: '/insurance'},
        {name: 'Contact us', link: '/contact'}
      ],
      good_colors: ['9B51E0', 'F2C94C', 'F2994A', '4F4F4F', 'EB5757', '27AE60', '2D9CDB', 'BB6BD9', '56CCF2'],
      check_message: '',
      img_path: '',
      create_loading: false,
      custom_states: {
        'Alabama':  ['BAMA' ,' ROLTYD' , 'BIRMIN' , 'BAMAGAL'],
        'Alaska':  ['NORTHRN' , 'OFFGRID' , 'FRESPRT', 'MOOSE'],
        'Arizona': ['GRDCAN' , 'FINEX' , 'CARDNLS' , 'CACTUS'],
        'Arkansas': ['LILROCK' , 'AR' , 'DMNDST8' , 'DUKHUNT'],
        'California':  ['HOLLYWD' , 'SURFUP' , '49ERS' , 'GLDS8'],
        'Colorado':  ['ASPEN' , 'WEED' , 'SNOWMAN' , 'SKIING'] ,
        'Connecticut': ['CT' , 'HARTFOR' , 'HEDGFND' , 'HUSKIES'],
        'Delaware': ['NASCAR' , 'CORN' , 'DE' , 'DOVER'],
        'Florida': ['DIZNEY' , 'FLOWRID' , 'GATOR' , 'BEACH'],
        'Georgia': ['PEACHY' , 'FALCONS' , 'ATL' , 'GA'],
        'Hawaii': ['SURFUP' , 'ALOHA ', 'HONOLU' , 'HI'],
        'Idaho': ['POTATO' , 'FARMGAL' ,  'BOISE' , 'GEMST8'],
        'Illinois': ['DEEPDSH' , 'PIZZA' , 'SOX' , 'BULLS '],
        'Indiana': ['INDY500' , 'POPCORN' ,' IN' , 'CORNY'],
        'Iowa': ['CRNFLD' ,'DESMOIN' , 'IA ', 'FARMLYF '],
        'Kansas': ['WIZARD' , 'TOPEKA' , 'SUNFLWR' , 'WICHITA'],
        'Kentucky': ['HORSE' , 'DURBY' ,  'KFC' ,' KY '],
        'Louisiana': ['CHIKEN' , 'FRIED' , 'ORLEANS', 'CRAFSH'],
        'Maine': ['LOBSTER' , 'FISHCHP', 'WESAIL' , 'CLMDIP'],
        'Maryland': ['CRABIN' , '7THST8' , 'BALTIMR' , 'ANAPOLS'],
        'Massachusetts': ['BOSTON' , 'REDSOX' , 'PATRIOTS ', 'HEDGFND'],
        'Michigan': ['DETROIT ', 'MOTRCTY', '8MILE' , 'LIONFAN'],
        'Minnesota': ['MN' , 'VIKING' , '10KLAKS' , 'DULUTH '],
        'Mississippi': ['RIVER' , 'ROTBEER' ,'MS', 'CHURCH'],
        'Missouri': ['OZARK' , 'CHIEFS' , 'MO' , 'ROYALS'],
        'Montana': ['BISON' , 'HELENA' , 'MT' , 'HANAMNT'],
        'Nebraska': ['OMAHA' , 'BRASKA' , 'CRNHUSK' , 'NE '],
        'Nevada': ['AREA21' , 'SINCITY' , 'VEGAS' , 'UFO '],
        'New Hampshire':  ['CONCORD' , 'WLDCATS' , 'NH' , 'GRANITE'],
        'New Jersey': ['NEWARK' , 'NJ' ,  'HUDSON' , 'TSLA '],
        'New Mexico': ['QURKEY' , 'NM' , 'HOLA' , 'CACTUS'],
        'New York':  ['NY' , 'BRONX' , 'LIBERTY' , 'WALLST'],
        'North Carolina': ['FLYTMDE ', 'NC' , 'RALEIGH' , 'PANTHRS'],
        'North Dakota': ['BARLEY' , 'BUFFALO' , 'FARGO' , 'ND'],
        'Ohio': ['WHITAIL' , 'BENGALS' , 'CINCIN' , 'OH'],
        'Oklahoma': ['NATIVE' , 'TULSA ', 'REDPPL ', 'OKC'],
        'Oregon': ['PRTLAND' , 'GOGREEN' , 'OR' ,'NIKE '],
        'Pennsylvania': ['BELL' , 'PENN ', 'AMISH' , 'PITSBUR'] ,
        'Rhode Island': ['VIOLET' , 'PROVDNC' , 'RI', 'RHODEY'],
        'South Carolina': ['GOLF' , 'COLUMBI' , 'PEACHY' , 'SC '],
        'South Dakota': ['FALLS' , 'SD' , 'RUSHMRE' , 'TOURIST'],
        'Tennessee': ['10SEE' , 'WHISKEY ', 'TITANS ', 'NASHVLE'],
        'Texas': ['COWBOY' , 'SPURS' , 'DESERT' , 'LONESTR'],
        'Utah': ['MORMON' , 'SLC ', 'MONOLTH' , 'REDROCK'],
        'Vermont':   ['FRENCH' , 'MAPLES', 'DAIRY' , 'VT '],
        'Virginia': ['TECH' , 'RICHMND' ,' VA' , 'DOGWOOD'],
        'Washington':  [' SEA' , 'SEAHWKS' , '206' , 'RAINR '],
        'West Virginia': ['CHRLSTN' , 'MNTN ', 'WV' , 'BIOTECH'],
        'Wisconsin': ['CHEESE ', 'GRENBAY' , 'DARYLND' , 'WI'],
        'Wyoming': ['YLWSTON' , 'DINOSOR ', 'GEYSER' , 'WY'],        
      },

      // TOASTS
      toasts: [],

      is_plate_created: false,

      categories: categories
    } 
  },

  mutations: {
    routeLink(state, link) {
      router.push(link)
    },

    
    CLEAR_IMG_PATH(state) {
      state.img_path = ''
    },

    DANGER_TOAST(state, message) {
      state.toasts.unshift({
        'message': message,
        'status': 'error'
      })
  
      setTimeout(() => {
        state.toasts.pop()
      }, 5000)
    },
  
    SUCCESS_TOAST(state, message) {
      state.toasts.unshift({
        'message': message,
        'status': 'success'
      })
  
      setTimeout(() => {
        state.toasts.pop()
      }, 5000)
    }
  },
  actions: {
    checkText({ state, getters }, args) {
      /*
      need to create search request and route to detail plate if needed
      :@param: plate_text : text which will be created
      :@param: route : if 'true' route to plate page
      :@oaram selected_state: state which need to this text
      */
      this.check_message = ''      
      let usa_state = args.selected_state || state.states[getters.getRandomInt] 
      axios.post(`${state.server}search/`,
        {
          text: args.plate_text,
          state: usa_state
        })
        .then((response) => {
          if (args.route) {
            router.push(`/${usa_state}/${response.data.created_data.text}`)
          } else {
            if (response.data.same_text_number === 0) {
              state.check_message = 'That will be the first number in your state with this text'
            } else {
              state.check_message = `Found ${response.data.same_text_number} similar numbers in your state`
            }
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },

    createPlate({ state }, args) {
      state.create_loading = true
      axios.post(`${state.server}plates/`,
        args.data)
        .then((response) => {
          state.img_path = response.data.img_path
          state.create_loading = false
          state.is_plate_created = true
        })
        .catch((error) => {
          console.log(error)
        })
    }

  },
  getters: {
    getRandomInt: state => {
      return Math.floor(Math.random() * Math.floor(state.states.length));
    }
  }
})
